import RebitAccount from "../models/RebitAccount";
export const RebitAccountMixin = {
  data() {
    return {
      rebitAccount: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new RebitAccount({
          id: undefined,
          holder: undefined,
          currency_acronym: undefined,
          accountable_id: null,
          type: 'Account',
          number: null,
          owner_operator_id: null,
          is_active: false,
          is_depositable: false,
          description: null,
          opening_balance: 0,
          real_balance: 0,
          monthly_turnover_limit: 0,
          ideal_balance: 0,
          auth_params: undefined,
          corporations: []
      })
    }
  }
}
